module.exports = __webpack_public_path__ + "static/img/cocina_15.9e89497f.png";